import React from 'react';
import * as S from './Button.styles';

interface IButton {
  name?: string;
  margin?: string;
  btnWidth?: sttring;
};

const Button: React.FC<IButton> = (props) => (
  <S.BookNowBtn {...props}>
    {props.name}
  </S.BookNowBtn>
);

export default Button;